import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';

const AnimatedText = () => {
  const [showBusiness, setShowBusiness] = useState(true);
  const [flipping, setFlipping] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setFlipping(true);

      // Wait until scaleY(0) is reached (~150ms), then switch word
      setTimeout(() => {
        setShowBusiness((prev) => !prev);
      }, 150);

      // Complete flip animation
      setTimeout(() => {
        setFlipping(false);
      }, 300); // total animation duration
    }, 1500);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <style>
        {`
          .flip-text {
            display: inline-block;
            transform-origin: center;
            transition: transform 0.3s ease;
          }

          .flipping {
            transform: scaleY(0);
          }
        `}
      </style>

      <span
        className={`flip-text ${flipping ? 'flipping' : ''}`}
        style={{
          color: '#ff671f',
          fontFamily: 'Satisfy',
          fontSize: '2.2rem',
        //   marginLeft: '1rem',
          minWidth: '150px'
        }}
      >
        {showBusiness ? 'Business' : 'Profession'}
      </span>
    </>
  );
};

export default AnimatedText;
